export interface DefaultRouteOption {
  label: string;
  route: string;
}

export const DEFAULT_ROUTE_OPTIONS: DefaultRouteOption[] = [];
